import { Box, TableCell, TableRow } from '@base-app';
import { styled } from '@/stitches.config';

export const StyledTableHeadRow = styled(TableRow, {
  color: '$darkBlue300',
  fontSize: '$4',
  lineHeight: '$6',
  fontWeight: '$bold',
  backgroundColor: '$white',
  variants: {
    disabled: {
      true: {
        color: '$coolGray100',
        pointerEvents: 'none',
      },
    },
  },
});

export const StyledTableHeadCell = styled(TableCell, {
  cursor: 'pointer',
  position: 'sticky',
  top: '0',
  zIndex: '$stickyHeader',
  background: '$white',
});

export const StyledTableHeadOrderIdCell = styled(StyledTableHeadCell, {
  cursor: 'auto',
  width: '30%',
});

export const StyledTableHeadDateReceivedCell = styled(StyledTableHeadCell, {
  width: '30%',
});

const StyledCaret = styled(Box, {
  display: 'inline-block',
  margin: '$1 $1',
  verticalAlign: 'center',
  width: '0',
  height: '0',
});

export const StyledCaretUp = styled(StyledCaret, {
  borderLeft: '$borderWidths$5 solid transparent',
  borderRight: '$borderWidths$5 solid transparent',
  borderBottom: '$borderWidths$5 solid $colors$black',
});

export const StyledCaretDown = styled(StyledCaret, {
  borderLeft: '$borderWidths$5 solid transparent',
  borderRight: '$borderWidths$5 solid transparent',
  borderTop: '$borderWidths$5 solid $colors$black',
});

export const StyledTableBodyCell = styled(TableCell, {
  border: '$0',
});

export const StyledTableBodyRow = styled(TableRow, {
  color: '$charcoal300',
});

export const StyledNotResultsRowText = styled(TableRow, {
  'tbody &:hover': {
    backgroundColor: 'transparent',
  },
});

export const StyledNotResultsCellText = styled(TableCell, {
  fontSize: '$5',
  fontWeight: '$medium',
  lineHeight: '$6',
  margin: '55px auto',
  textAlign: 'center',
});

export const StyledError = styled(Box, {
  color: '$error',
});
